import { jsxs as t, jsx as e } from "react/jsx-runtime";
import m from "./index.es5732.js";
import { Heading as a } from "./index.es507.js";
import { MenuText as l } from "./index.es508.js";
const f = ({
  title: i,
  content: n,
  testId: o,
  additionalLink: r
}) => /* @__PURE__ */ t("div", { className: m.confirmationDialogContent, "data-testid": o, children: [
  /* @__PURE__ */ e(a, { variant: "h2", element: "span", id: "modal-title", children: i }),
  /* @__PURE__ */ t("div", { children: [
    /* @__PURE__ */ e(l, { element: "p", children: n }),
    r
  ] })
] });
export {
  f as ConfirmationDialogBoxContent
};
//# sourceMappingURL=index.es875.js.map
